module.exports = __webpack_public_path__ + "img/TopState1G.90745d90.png";